// extracted by mini-css-extract-plugin
module.exports = {"actions":"Price_actions__rvC2d","price":"Price_price__IhTq2","priceBreakdown":"Price_priceBreakdown__CyGIM","salesPrice":"Price_salesPrice__VtEns"};
module.exports.__checksum = "7368e53753c4"
